module.exports = __webpack_public_path__ + "img/pp-14.28387385.jpg";